import baseUrl from './baseUrl';
import isTokenExpired from '../helpers/isTokenExpired';

const URL_GET_CHAMADOS_BUSCA = `${baseUrl}/chamado/busca`;

const getChamadosBusca = async (campo, valor, role, page = 1, limit = 50, email, campo2 = '', valor2 = '') => {
  try {
    const token = window.localStorage.getItem('token');

    if (token) {
      if (isTokenExpired(token)) {
        window.localStorage.clear();
        window.location.replace('/');

        return;
      }
    }

    const queryParams = new URLSearchParams({
      campo,
      valor,
      role,
      page,
      limit
    });

    if (campo2 && valor2) {
      queryParams.append('campo2', campo2);
      queryParams.append('valor2', valor2);
    }

    const data = await fetch(
      `${URL_GET_CHAMADOS_BUSCA}?${queryParams.toString()}`, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          email
        }
      }
    );

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }
      
    const response = await data.json();

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default getChamadosBusca;
